import clsx from 'clsx';

import styles from './Table.module.css';

import type { TableProps, ColumnType } from './Table.types';

export function Table<T>({ className, columns, dataSource, ellipsis, rowKey }: TableProps<T>) {
  const getRowKey = (record: T, index: number) => {
    if (typeof rowKey === 'function') return rowKey(record);
    if (typeof rowKey === 'string') return record[rowKey] as unknown as string | number;
    return index;
  };

  return (
    <div className={clsx(styles.tableContainer, ellipsis ? styles.ellipsis : '')}>
      <table className={`${styles.table} ${className || ''}`}>
        <thead>
          <tr>
            {columns.map((col: ColumnType<T>) => (
              <th
                key={col.key || String(col.dataIndex)}
                style={{
                  textAlign: col.align,
                  width: col.width ? `${col.width}%` : undefined,
                }}
              >
                {col.title}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {dataSource.map((record, rowIndex) => (
            <tr key={getRowKey(record, rowIndex)}>
              {columns.map((col: ColumnType<T>) => {
                const value = record[col.dataIndex];
                const content = col.render ? col.render(value, record, rowIndex) : value;

                return (
                  <td
                    key={col.key || String(col.dataIndex)}
                    style={{
                      textAlign: col.align,
                      width: col.width ? `${col.width}%` : undefined,
                    }}
                  >
                    {content as React.ReactNode}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
